import React from 'react';
import { FormattedMessage } from 'react-intl';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

type Props = {
  hiddenResults: number;
  totalHits: number;
  showHiddenResults: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export class TopLimitationMessage extends React.Component<Props> {
  componentDidMount() {
    const { totalHits, hiddenResults } = this.props;
    const resultsShown = totalHits - hiddenResults;
    doctrineAnalytics('Search CutResultViewed', {
      nb_results_shown: resultsShown,
      nb_results_hidden: hiddenResults,
    });
  }

  render() {
    const { hiddenResults, showHiddenResults } = this.props;
    return (
      <div className="top-limitation">
        <FormattedMessage id="app.pages.search.toplimitation.title" />{' '}
        <button
          type="button"
          name="showHiddenResults"
          className="top-limitation__link"
          onClick={showHiddenResults}
        >
          <FormattedMessage
            id="app.pages.search.toplimitation.button"
            values={{
              hiddenResults,
            }}
          />
        </button>
      </div>
    );
  }
}
